module.exports = "/_next/static/videos/10-8243908c651987f8a1b48311592605cb.webm";